import styled from 'styled-components';

export const Container = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border-radius: 12px;
  padding: 16px 20px 16px 20px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
`;

export const TopContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 16px;
`;

export const NamesContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const Avatar = styled.img`
  width: 78.5px;
  height: 78.5px;
  border-radius: 20px;
`;

export const NameContainer = styled.div`
  gap: 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const DisplayName = styled.h3`
  font-size: 20px;
  color: #4D4D4D;
`;

export const JobDescription = styled.p`
  font-size: 12px;
  color: #666666;
`;

export const UserName = styled.h2`
  font-size: 12px;
  color: #6E30E8;
  margin-top: 12px;
`;

export const NumbersContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  gap: 16x;
`;

export const Numbers = styled.h1`
  font-size: 14px;
  font-weight: 700;
  margin-right: 4px;
  color: #4D4D4D;
`;

export const Info = styled.p`
  font-size: 14px;
  margin-right: 12px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;
`;

export const SobreContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 360px;
  margin-bottom: 17px;
`;

export const SobreTitle = styled.h1`
  font-size: 16px;
  font-weight: 400;
  color: #000;
`;

export const SobreText = styled.p`
  font-size: 16px;
  color: #000;
`;  

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 8px;
`;

export const LinksTitle = styled.h1`
  font-size: 16px;
  font-weight: 400;
  color: #000;
  margin-bottom: 10px;
`;

export const LinkIcons = styled.div`
  font-size: 16px;
  color: #000;
  margin-top: 10px;
`;